import { useState, useEffect, useRef } from "react";
import { getCotizacion } from "../../service/AffariService";
import Cabecera from "./components/Cabecera";
import { useNavigate } from "react-router-dom";
import ContactoDialog from "../contacto/ContactoDialog";
import DatosDialog from "../../features/clientes/components/dialogs/DatosDialog";
import DeudaDialog from "../../features/clientes/components/dialogs/DeudaDialog";
import VentaDialog from "../../features/clientes/components/dialogs/VentaDialog";
import TicketsDialog from "../../features/clientes/components/dialogs/TicketsDialog";
import HeaderSteps from "../../components/ui/Steps";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import { Toast } from "primereact/toast";
import DetalleCotizacion from "./components/DetalleCotizacion";
import PropuestasDialog from "../../features/clientes/components/dialogs/PropuestasDialog.js";
import { useGlobalContext } from "../../Config";
import { useOffline } from "../../offline/OfflineContext";
import {
  obtenerClienteOffline,
  obtenerDatoClienteOffline,
  buscarContactosPorClienteOffline,
  buscarObrasPorClienteOffline,
  buscarDeudaClienteOffline,
  listarAlmacenesOffline,
  listarCondicionesPagoOffline,
  listarEstadosOffline,
  listarValidezsOffline,
} from "../../offline/offlineCatalogoService";

const Cotizacion = (props) => {
  const navigate = useNavigate();
  const [codigo, setCodigo] = useState("");
  const [tipoDocumento, settipoDocumento] = useState("");
  const [data, setData] = useState({});
  const [isDetalleVisible, setIsDetalleVisible] = useState(false);
  const [isContactoDialogVisible, setIsContactoDialogVisible] = useState(false);
  const [isDatosDialogVisible, setIsDatosDialogVisible] = useState(false);
  const [isDeudaDialogVisible, setIsDeudaDialogVisible] = useState(false);
  const [isVentaDialogVisible, setIsVentaDialogVisible] = useState(false);
  const [isPropuestasDialogVisible, setIsPropuestasDialogVisible] =
    useState(false);
  const [isTicketsDialogVisible, setIsTicketsDialogVisible] = useState(false);
  const [collapsedClient, setCollapsedClient] = useState(false);
  const [collapsedFolio, setCollapsedFolio] = useState(false);
  const [idCotizacion, setIdCotizacion] = useState("");
  const toast = useRef(null);
  const { isDinar, isSack } = useGlobalContext();
  const [loading, setLoading] = useState(false);
  const { offlineMode } = useOffline();

  const cargarCotizacionOffline = async (
    codigoCliente,
    tipoDocumentoParam,
    propuestasFromQuery,
  ) => {
    const cliente = await obtenerClienteOffline(codigoCliente);
    const dato = await obtenerDatoClienteOffline(codigoCliente);
    const contactos = await buscarContactosPorClienteOffline(codigoCliente);
    const obras = await buscarObrasPorClienteOffline(codigoCliente);
    const deuda = await buscarDeudaClienteOffline(codigoCliente);
    const almacenes = await listarAlmacenesOffline();
    const condicionesPago = await listarCondicionesPagoOffline();
    const estados = await listarEstadosOffline();
    const validezs = await listarValidezsOffline();

    const listaPrecioCodigo = cliente?.lista_precio || "";
    const almacenCodigo = listaPrecioCodigo.includes("-")
      ? listaPrecioCodigo.split("-").pop()
      : "";

    const almacenDefault = {
      almacen: almacenCodigo,
      sucursal: almacenCodigo,
      oficina: cliente?.zona || "",
    };

    const almacenesNormalizados = almacenes.map((item) => ({
      ...item,
      almacen: item.almacen,
      sucursal: item.sucursal || item.almacen,
      oficina: item.oficina || cliente?.zona || "",
    }));

    return {
      cliente: {
        ...cliente,
        razonSocial: cliente?.razon_social || "",
        listaPrecio: {
          codigo: listaPrecioCodigo,
          descripcion: listaPrecioCodigo,
          almacen: almacenCodigo,
        },
        vendedor: {
          codigo: cliente?.vendedor || "",
          descripcion: cliente?.vendedor || "",
        },
        condicionPago: {
          codigo: cliente?.condicion_pago || "",
          descripcion: cliente?.condicion_pago || "",
        },
        propuestas: propuestasFromQuery || 0,
      },

      dato: {
        ...dato,
        estado: dato?.estado || "SIN DATOS",
        credito: dato?.credito || "0",
        saldoFactura: dato?.saldo_factura || "0",
        saldoOrden: dato?.saldo_orden || "0",
      },

      contactos,
      contacto: contactos?.[0] || null,

      obras,
      obra: obras?.[0]?.id || null,

      deuda,

      almacen: almacenDefault,
      almacens: almacenesNormalizados,
      centro: almacenCodigo,
      listaPrecio: listaPrecioCodigo,

      condiciones: condicionesPago,
      proyectos: obras,
      proyecto: obras?.[0]?.id || null,

      estados,
      estado: estados?.[0]?.id || null,

      validezs,
      validez: validezs?.[0]?.id || null,

      interfaz: "RETAIL",

      documento:
        tipoDocumentoParam === "boleta"
          ? "Boleta"
          : tipoDocumentoParam === "factura"
          ? "Factura"
          : "Nota de Venta",
    };
  };

  useEffect(() => {
    const {
      codigo: codigoParam,
      tipo: tipoDocumentoParam,
      propuestas: propuestasParam,
    } = props.location.search
      .split("?")[1]
      .split("&")
      .reduce((acc, item) => {
        const [key, value] = item.split("=");
        acc[key] = value;
        return acc;
      }, {});

    setCodigo(codigoParam);
    settipoDocumento(tipoDocumentoParam);
    const propuestasFromQuery =
      propuestasParam != null ? Number(propuestasParam) : null;

    if (codigoParam) {
      (async () => {
        try {
          setLoading(true);
          const data = offlineMode
            ? await cargarCotizacionOffline(
                codigoParam,
                tipoDocumentoParam,
                propuestasFromQuery,
              )
            : await getCotizacion(codigoParam);
          if (data) {
            if (!data.estado && data.estados && data.estados.length > 0) {
              data.estado = data.estados[0];
            }
            if (tipoDocumentoParam === "boleta") {
              data.documento = "Boleta";
            }
            if (tipoDocumentoParam === "factura") {
              data.documento = "Factura";
            }
            if (tipoDocumentoParam === "nota-venta") {
              data.documento = "Nota de Venta";
            }
            if (data.contactos && data.contactos.length > 0 && !data.contacto) {
              data.contacto = data.contactos[0];
            }
            if (
              propuestasFromQuery != null &&
              !Number.isNaN(propuestasFromQuery)
            ) {
              data.cliente = data.cliente || {};
              data.cliente.propuestas = propuestasFromQuery;
            }
            if (data.interfaz === "MAYORISTA") {
              data.almacen = null;
            }

            setData(data);
          }
        } catch (error) {
          console.error("Error al cargar la cotización:", error);
        } finally {
          setLoading(false);
        }
      })();
    } else {
      setLoading(false);
    }
  }, [props.location.search, offlineMode]);

  const handleContactosChange = (lista) => {
    setData((prevData) => {
      const contactos = Array.isArray(lista) ? lista : [];
      let contacto = prevData.contacto;
      if (contacto?.id) {
        const match = contactos.find((item) => item.id === contacto.id);
        if (match) {
          contacto = match;
        }
      }
      if (!contacto && contactos.length > 0) {
        contacto = contactos[0];
      }
      return { ...prevData, contactos, contacto };
    });
  };

  return (
    <>
      <Toast
        ref={toast}
        position="top-right"
        appendTo={document.body}
        baseZIndex={4000}
      />

      {/* sub titulo */}
      <div className="flex flex-column md:flex-row md:align-items-center md:justify-content-between py-0">
        <div className="flex align-items-center">
          <Button
            type="button"
            className="p-button-rounded p-button-text text-600"
            icon="pi pi-arrow-left"
            onClick={() => navigate(`/${tipoDocumento}`)}
            tooltip="Volver"
          />
          <h4 className="m-0 text-lg">
            Ingreso de{" "}
            {tipoDocumento === "boleta"
              ? "Cotización Boleta"
              : tipoDocumento === "nota-venta"
              ? "Nota de Venta"
              : tipoDocumento === "factura"
              ? "Cotización Factura"
              : ""}
          </h4>
        </div>
        <HeaderSteps activeIndex={1} tipoDocumento={tipoDocumento} />
      </div>

      {/* cotizacion */}
      <div className="p-fluid">
        <Panel
          header={
            <div className="flex align-items-center">
              <div className="surface-100 border-circle w-3rem h-3rem flex align-items-center justify-content-center mr-3">
                <i className="pi pi-user text-primary text-lg"></i>
              </div>
              <span className="text-lg text-900">
                {" "}
                {`Cliente ${
                  isSack
                    ? `${
                        data.interfaz === "MAYORISTA" ? "Mayorista" : "Retail"
                      }`
                    : isDinar
                    ? ""
                    : ""
                } `}
              </span>
            </div>
          }
          toggleable
          collapsed={collapsedClient}
          onToggle={(e) => setCollapsedClient(e.value)}
          className="border-none shadow-1 border-round-xl overflow-hidden surface-card"
        >
          <div className="p-2">
            {/* propuestas pendientes */}
            {Number(data?.cliente?.propuestas) > 0 && (
              <div className="w-full bg-pink-100 border-round-xl shadow-1  flex align-items-center justify-content-center">
                <Button
                  className="p-button-link text-900 advertencia-link"
                  onClick={() => {
                    setIsPropuestasDialogVisible(true);
                    setCodigo(codigo);
                  }}
                  label={
                    <>
                      <i className="pi pi-exclamation-triangle text-primary text-lg" />{" "}
                      ADVERTENCIA: El cliente tiene cotizaciones en estado
                      propuesta
                    </>
                  }
                />
              </div>
            )}

            {/* cabecera cliente */}
            <Cabecera
              tipoDocumento={tipoDocumento}
              data={data}
              setData={setData}
              setCodigo={setCodigo}
              setIdCotizacion={setIdCotizacion}
              setIsDetalleVisible={setIsDetalleVisible}
              setIsContactoDialogVisible={setIsContactoDialogVisible}
              setIsDatosDialogVisible={setIsDatosDialogVisible}
              setIsDeudaDialogVisible={setIsDeudaDialogVisible}
              setIsVentaDialogVisible={setIsVentaDialogVisible}
              setIsTicketsDialogVisible={setIsTicketsDialogVisible}
              setCollapsedClient={setCollapsedClient}
              setCollapsedFolio={setCollapsedFolio}
              toastRef={toast}
              loading={loading}
              setLoading={setLoading}
            />
          </div>
        </Panel>
      </div>

      <div className="p-fluid mt-2">
        {/* detalle de la cotizacion */}
        {isDetalleVisible && (
          <Panel
            header={
              <div className="flex align-items-center">
                <div className="surface-100 border-circle w-3rem h-3rem flex align-items-center justify-content-center mr-3">
                  {" "}
                  <i className="pi pi-file text-primary text-lg"></i>{" "}
                </div>
                <span className="text-lg text-900">
                  {" "}
                  {`Folio: #${idCotizacion}`}
                </span>
              </div>
            }
            toggleable
            collapsed={collapsedFolio}
            onToggle={(e) => setCollapsedFolio(e.value)}
            className="border-none shadow-1 border-round-xl overflow-hidden surface-card"
          >
            <DetalleCotizacion
              interfaz={data.interfaz}
              idCotizacion={idCotizacion}
              data={data}
              setData={setData}
              isDetalleVisible={isDetalleVisible}
              setIsDetalleVisible={setIsDetalleVisible}
            />
          </Panel>
        )}
      </div>

      {/* ventanas dialog */}
      <ContactoDialog
        visible={isContactoDialogVisible}
        onHide={() => setIsContactoDialogVisible(false)}
        data={data}
        onContactosChange={handleContactosChange}
      />

      <DatosDialog
        visible={isDatosDialogVisible}
        onCancel={() => {
          setIsDatosDialogVisible(false);
        }}
        codigo={codigo}
      />

      <DeudaDialog
        visible={isDeudaDialogVisible}
        onCancel={() => {
          setIsDeudaDialogVisible(false);
        }}
        codigo={codigo}
      />

      <VentaDialog
        visible={isVentaDialogVisible}
        onCancel={() => {
          setIsVentaDialogVisible(false);
        }}
        codigo={codigo}
      />

      <TicketsDialog
        visible={isTicketsDialogVisible}
        onCancel={() => {
          setIsTicketsDialogVisible(false);
        }}
        codigo={codigo}
      />

      <PropuestasDialog
        visible={isPropuestasDialogVisible}
        onCancel={() => {
          setIsPropuestasDialogVisible(false);
        }}
        codigo={codigo}
      />
    </>
  );
};

export default Cotizacion;
